module.exports = __webpack_public_path__ + "static/media/instagram-icon.7abf4f2b.svg";